const resolve = (path, obj = self, separator = '.') => {
  const properties = Array.isArray(path) ? path : path.split(separator);
  return properties.reduce((prev, curr) => prev && prev[curr], obj);
};

const getPercentage = (students, path) => {
  return Math.ceil(
    (students.filter(student => resolve(path, student)).length /
      students.length) *
      100
  );
};

export { getPercentage };
